/*
 * サブシステム名：マスタ管理
 * 機能名：車両マスタ一覧
 */

import { mapGetters } from 'vuex'
import flowMixin from '@/mixins/flowMixins'
import filter from '@/rahmen/utils/filters'

import header from '@/ddv2.library/header'

const DdSearchList = () => import('@/components/DdSearchList')
const DdCodeTextBox = () => import('../../components/DdCodeTextBox.vue')
const DdRadioButton = () => import('@/components/DdRadioButton')
const DdTextBox = () => import('../../components/DdTextBox.vue')

export default {
  name: 'MstSharyoList',
  mixins: [flowMixin],
  components: {
    DdSearchList,
    DdCodeTextBox,
    DdRadioButton,
    DdTextBox
  },
  data: () => ({
    // 一覧制御用
    selected: [],
    itemsPerPage: 100,
    page: 1,
    isConditionHide: false,
    isCsvDownloader: false,
    isPdfDownloader: false,

    conditions: {
      sharyoCd: '',
      hacchusakiFlgKubun: '0',
      eigyoshoCd: '',
      hacchusakiCd: '',
      sharyoNo: '',
      jidoshaHyojiNm: ''
    },
    headersEigyoshoList: header.mstEigyoshoHeaders,
    headersHacchusakiList: header.mstTorihikisakiHeaders,
    modeKengen: 0
  }),
  computed: {
    ...mapGetters({
      viewTitle: 'system/viewTitle',
      helpUseFlg: 'DDMasters/helpUseFlg',
      eigyoshoList: 'DDMasters/mstEigyosho',
      hacchusakiList: 'DDMasters/mstTorihikisaki',
      eigyoshoLockFlg: 'users/anotherEigyoshoCtrlFlg',
      userEigyoshoCd: 'users/eigyoshoCd'
    }),
    eigyoshoReadOnly () {
      const self = this
      return !self.eigyoshoLockFlg
    },
    filteredEigyoshoList () {
      const target = filter.dateFormatter(new Date())
      return this.eigyoshoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.eigyoshoCd > elem2.eigyoshoCd) { return 1 }
        if (elem1.eigyoshoCd === elem2.eigyoshoCd) { return 0 }
        return -1
      })
    },
    filteredHacchusakiList () {
      // 発注先限定
      const target = filter.dateFormatter(new Date())
      return this.hacchusakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.hacchusakiFlg === true && elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.torihikisakiCd > elem2.torihikisakiCd) { return 1 }
        if (elem1.torihikisakiCd === elem2.torihikisakiCd) { return 0 }
        return -1
      })
    },
    filteredRows () {
      return this.rows.map((elem) => {
        elem.nextShakenYmdDisp = ![undefined, null, ''].includes(elem.nextShakenYmd) ? filter.dateFormatter(elem.nextShakenYmd) : ''
        elem.nextOilYmdDisp = ![undefined, null, ''].includes(elem.nextOilYmd) ? filter.dateFormatter(elem.nextOilYmd) : ''
        if (elem.haishaYmd !== null) {
          elem.haishaYmdDisp = filter.dateFormatter(elem.haishaYmd)
        }
        if (elem.konyuYmd !== null) {
          elem.konyuYmdDisp = filter.dateFormatter(elem.konyuYmd)
        }
        if (elem.tekiyoStartYmd !== null) {
          elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        }
        if (elem.tekiyoEndYmd !== null) {
          elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        }
        if (elem.saidaisekisaiRyo !== null) {
          elem.saidaisekisaiRyoDisp = filter.numericFormatter(elem.saidaisekisaiRyo)
        }
        if (elem.nenpi !== null) {
          elem.nenpiDisp = filter.numericFormatter(elem.nenpi)
        }
        if (elem.konyuKakaku !== null) {
          elem.konyuKakakuDisp = filter.numericFormatter(elem.konyuKakaku)
        }
        if (elem.torokuTesuryo !== null) {
          elem.torokuTesuryoDisp = filter.numericFormatter(elem.torokuTesuryo)
        }
        if (elem.yoteiShiyoNensu !== null) {
          elem.yoteiShiyoNensuDisp = filter.numericFormatter(elem.yoteiShiyoNensu)
        }
        if (elem.jidoshaZeiKingaku !== null) {
          elem.jidoshaZeiKingakuDisp = filter.numericFormatter(elem.jidoshaZeiKingaku)
        }
        if (elem.juryoZei !== null) {
          elem.juryoZeiDisp = filter.numericFormatter(elem.juryoZei)
        }
        if (elem.shutokuZeiKingaku !== null) {
          elem.shutokuZeiKingakuDisp = filter.numericFormatter(elem.shutokuZeiKingaku)
        }
        if (elem.jibaisekiHokenKingaku !== null) {
          elem.jibaisekiHokenKingakuDisp = filter.numericFormatter(elem.jibaisekiHokenKingaku)
        }
        if (elem.sharyoHokenKingaku !== null) {
          elem.sharyoHokenKingakuDisp = filter.numericFormatter(elem.sharyoHokenKingaku)
        }
        if (elem.taijinHokenKingaku !== null) {
          elem.taijinHokenKingakuDisp = filter.numericFormatter(elem.taijinHokenKingaku)
        }
        if (elem.taibutsuHokenKingaku !== null) {
          elem.taibutsuHokenKingakuDisp = filter.numericFormatter(elem.taibutsuHokenKingaku)
        }
        if (elem.kamotsuHokenKingaku !== null) {
          elem.kamotsuHokenKingakuDisp = filter.numericFormatter(elem.kamotsuHokenKingaku)
        }
        if (elem.hyojiOrder !== null) {
          elem.hyojiOrderDisp = filter.numericFormatter(elem.hyojiOrder)
        }
        return elem
      })
    },
    isCsvButtonDisabled () {
      return this.rows.length === 0
    },
    isAddButtonDisplay () {
      if (this.modeKengen === 0) {
        return false
      }
      return true
    }
  },
  created () {
  },
  mounted () {
    this.initialize()
  },
  beforeRouteUpdate (to, from, next) {
    this.$refs.initialize()
    next()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rows: this.rows,
        conditions: this.conditions,
        searchText: this.searchText
      }
    },
    initialize: function () {
      const self = this
      const opt = {
        loadMasters: ['msteigyosho', 'msttorihikisaki'],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            console.log('MstSharyoList.defineHeaderPromise')
            self.headers = [
              { text: '編集', value: 'actions', sortable: false, width: '20px' },
              // { text: '車両コード', value: 'sharyoCd' },
              { text: '車両番号', value: 'sharyoNo' },
              { text: '所有区分', value: 'hacchusakiFlgKubun' },
              { text: '営業所', value: 'eigyoshoNm' },
              { text: '発注先', value: 'hacchusakiNm' },
              { text: '車両表示名', value: 'jidoshaHyojiNm' },
              { text: '自動車登録番号', value: 'torokuNo' },
              { text: '車種種別', value: 'shashuSbtNm' },
              { text: '次回車検日', value: 'nextShakenYmdDisp' },
              { text: '次回オイル交換日', value: 'nextOilYmdDisp' },
              /*
              { text: '車両グループ種別１', value: 'sharyoGroupSbt1Nm' },
              { text: '車両グループ種別２', value: 'sharyoGroupSbt2Nm' },
              { text: '車両グループ種別３', value: 'sharyoGroupSbt3Nm' },
              { text: '車両グループ種別４', value: 'sharyoGroupSbt4Nm' },
              { text: '車両グループ種別５', value: 'sharyoGroupSbt5Nm' },
              { text: '運賃車種種別', value: 'unchinShashuSbtNm' },
              { text: '廃車年月日', value: 'haishaYmdDisp', align: 'center' },
              { text: '積載量', value: 'saidaisekisaiRyoDisp', align: 'end' },
              { text: '燃費', value: 'nenpiDisp', align: 'end' },
              { text: '購入年月日', value: 'konyuYmdDisp', align: 'center' },
              { text: '購入価格', value: 'konyuKakakuDisp', align: 'end' },
              { text: '登録手数料', value: 'torokuTesuryoDisp', align: 'end' },
              { text: '予定使用年数', value: 'yoteiShiyoNensuDisp', align: 'end' },
              { text: '自動車税金額', value: 'jidoshaZeiKingakuDisp', align: 'end' },
              { text: '重量税金額', value: 'juryoZeiDisp', align: 'end' },
              { text: '取得税金額', value: 'shutokuZeiKingakuDisp', align: 'end' },
              { text: '自賠責保険金額', value: 'jibaisekiHokenKingakuDisp', align: 'end' },
              { text: '車両保険金額', value: 'sharyoHokenKingakuDisp', align: 'end' },
              { text: '対人保険金額', value: 'taijinHokenKingakuDisp', align: 'end' },
              { text: '対物保険金額', value: 'taibutsuHokenKingakuDisp', align: 'end' },
              { text: '貨物保険金額', value: 'kamotsuHokenKingakuDisp', align: 'end' },
               */
              { text: '適用開始年月日', value: 'tekiyoStartYmdDisp', align: 'center' },
              { text: '適用終了年月日', value: 'tekiyoEndYmdDisp', align: 'center' },
              { text: '表示順', value: 'hyojiOrderDisp', align: 'end' }
            ]
            resolve()
          })
        },
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            self.conditions = {
              sharyoCd: '',
              hacchusakiFlgKubun: '0',
              eigyoshoCd: !self.eigyoshoLockFlg ? self.userEigyoshoCd : '',
              hacchusakiCd: '',
              sharyoNo: '',
              jidoshaHyojiNm: ''
            }
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          console.log('MstSharyoList.savedInputRestorePromise', c)
          // ユーザ保存項目の復元
          self.conditions = { ...self.conditions, ...c }
          return new Promise(resolve => {
            self.loadFromCache()
              .then((c) => {
                console.log('MstSharyoList.savedInputRestorePromise', c)
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          console.log('MstSharyoList.researchPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value ? c.cache.value.conditions || {} : self.conditions
            self.onSearchButtonClick()
            resolve()
            // self.search().then(() => {
            //   resolve()
            // })
          })
        },
        restoreViewPromise: (c) => {
          console.log('MstSharyoList.restoreViewPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value ? c.cache.value.conditions || {} : self.conditions
            self.searchText = c.cache.value ? c.cache.value.searchText || '' : self.searchText
            self.rows = c.cache.value ? c.cache.value.rows || [] : self.rows
          })
        },
        settingButtonStatePromise: (kengen) => {
          console.log('MstSharyoList.settingButtonStatePromise', kengen)
          return new Promise(resolve => {
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }

            this.$nextTick(() => {
              document.getElementById('heavy-element').style.display = ''
            })

            resolve()
          })
        }
      }
      self.initializeForViewer(opt)
    },
    onSearchButtonClick: function (e) {
      this.selected = []
      this.page = 1

      const self = this
      const opt = {
        searchRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/vwCMstSharyo/search', self.conditions)
              .then((data) => {
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          self.rows = data.payload

          const cache = {
            rows: self.rows,
            conditions: self.conditions,
            searchText: self.searchText
          }
          self.saveToChache(cache)
            .then(() => {
            })
        },
        getSavedInputMethod: function () {
          return {
            hacchusakiFlgKubun: self.conditions.hacchusakiFlgKubun
          }
        }
      }
      this.search(opt)
    },
    clear: function () {
      const opt = {
        clearInputsPromise: () => {
          return new Promise(resolve => {
            this.conditions = {
              sharyoCd: '',
              hacchusakiFlgKubun: '0',
              eigyoshoCd: !this.eigyoshoLockFlg ? this.userEigyoshoCd : '',
              hacchusakiCd: '',
              sharyoNo: '',
              jidoshaHyojiNm: ''
            }
            this.searchText = ''
            this.rows = []
            this.selected = []
            this.page = 1
            resolve()
          })
        }
      }
      this.clearInputs(opt)
    },
    onClearButtonClick: function (e) {
      this.Effects.loadStart()
      this.clear()
    },
    onRowDoubleClick: function (e, f) {
      console.log(e, f)
      this.Effects.loadStart()
      this.transition(0, { id: f.item.id })
    },
    onRowEditButtonClick: function (item) {
      // 画面遷移
      this.Effects.loadStart()
      this.transition(0, { id: item.id })
    },
    onCreateButtonClick: function (e) {
      console.log(e)
      this.Effects.loadStart()
      this.transition(0, { id: 0 })
    },
    searchValidate: function () {
      return true
    }
  }
}
